import * as React from 'react';
import { useState, useEffect } from "react";
import axios from "axios";
import { useDispatch, useSelector } from "react-redux";

import { styled } from '@mui/material/styles';
import Autocomplete from '@mui/material/Autocomplete';
import Box from '@mui/material/Box';
import Paper from '@mui/material/Paper';
import Grid from '@mui/material/Grid';
import Stack from '@mui/material/Stack';
import TextField from '@mui/material/TextField';
import Button from '@mui/material/Button';
import Checkbox from '@mui/material/Checkbox';
import Radio from '@mui/material/Radio';
import RadioGroup from '@mui/material/RadioGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import FormControl from '@mui/material/FormControl';
import FormLabel from '@mui/material/FormLabel';
import Rating from '@mui/material/Rating';
import Typography from '@mui/material/Typography';
import Switch from '@mui/material/Switch';
import Container from '@mui/material/Container';
import Alert from '@mui/material/Alert';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import Slide from '@mui/material/Slide';
import CircularProgress from '@mui/material/CircularProgress';
import Breadcrumbs from '@mui/material/Breadcrumbs';
import Link from '@mui/material/Link';

import PropTypes from 'prop-types';
import AppBar from '@mui/material/AppBar';
import CssBaseline from '@mui/material/CssBaseline';
import Divider from '@mui/material/Divider';
import Drawer from '@mui/material/Drawer';
import IconButton from '@mui/material/IconButton';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import ListItemButton from '@mui/material/ListItemButton';
import ListItemText from '@mui/material/ListItemText';
import MenuIcon from '@mui/icons-material/Menu';
import Toolbar from '@mui/material/Toolbar';

import Menu from '@mui/material/Menu';
import Avatar from '@mui/material/Avatar';
import Tooltip from '@mui/material/Tooltip';
import MenuItem from '@mui/material/MenuItem';
import AdbIcon from '@mui/icons-material/Adb';


// --- Menu admin 

const itemsMenuAdminStudio = [
  { text: 'Tipologie', href: '/admin/types' },
  { text: 'Servizi', href: '/admin/services' },
  { text: 'Clienti', href: '/admin/customers' },
  { text: 'Utenti', href: '/admin/users' },
  { text: 'Categorie', href: '/admin/categories' },
  { text: 'Prodotti', href: '/admin/products' },
  { text: 'Ordini', href: '/admin/orders' },
  { text: 'Pagamenti', href: '/admin/payments' },
  { text: 'Messaggi', href: '/admin/messages' },
  { text: 'Chat', href: '/admin/chats' },
  { text: 'Analisi', href: '/admin/analytics' },
  { text: 'Configura', href: '/admin/configs' },
]

const itemsMenuAdminShop = [
  //  { text: 'Tipologie', href: '/admin/types' },
  //  { text: 'Servizi', href: '/admin/services' },
  { text: 'Clienti', href: '/admin/customers' },
  { text: 'Utenti', href: '/admin/users' },
  { text: 'Categorie', href: '/admin/categories' },
  { text: 'Prodotti', href: '/admin/products' },
  { text: 'Ordini', href: '/admin/orders' },
  { text: 'Pagamenti', href: '/admin/payments' },
  { text: 'Messaggi', href: '/admin/messages' },
  { text: 'Chat', href: '/admin/chats' },
  { text: 'Analisi', href: '/admin/analytics' },
  { text: 'Configura', href: '/admin/configs' },
  //  { text: 'Logout', href: '/' },
]


const itemsMenuAdminPlanner = [
  { text: 'Tipologie', href: '/admin/types' },
  { text: 'Servizi', href: '/admin/services' },
  { text: 'Messaggi', href: '/admin/messages' },
  { text: 'Clienti', href: '/admin/customers' },
  { text: 'Utenti', href: '/admin/users' },
  { text: 'Analisi', href: '/admin/analytics' },
  { text: 'Configura', href: '/admin/configs' },
  { text: 'Chat', href: '/admin/chats' },
  { text: 'Categorie', href: '/admin/categories' },
  { text: 'Prodotti', href: '/admin/products' },
  { text: 'Ordini', href: '/admin/orders' },
  { text: 'Pagamenti', href: '/admin/payments' },
  //  { text: 'Logout', href: '/' },
]

const AdminMenuComponent = () => {

  const { userInfo } = useSelector((state) => state.userRegisterLogin);

  const [open, setOpen] = React.useState(false);
  const [anchorElNavAdmin, setAnchorElNavAdmin] = React.useState(null);

  const [applicativo, setApplicativo] = useState("");
  const [isShopActive, setIsShopActive] = useState("");
  const [isIconLoginActive, setIsIconLoginActive] = useState("");

  const getConfigByProgressivoApiRequest = async (progressivoRagSoc) => {
    console.log("[getConfigByProgressivoApiRequest] leggo const con progressivo =", progressivoRagSoc);
    const url = `/api/configs/progressivo/` + progressivoRagSoc;
    const { data } = await axios.get(url);
    return data
  }

  const handleOpenNavMenu = (event) => {
    setAnchorElNavAdmin(event.currentTarget);
  };

  const handleCloseNavMenu = () => {
    setAnchorElNavAdmin(null);
  };

  const handleClickOpen = () => {
    setOpen(true);
  };

  useEffect(() => {
    getConfigByProgressivoApiRequest('0001').then((data) => {
      console.log(`data =`, data);
      setApplicativo(data?.applicativo);
      setIsShopActive(data?.isShopActive);
      setIsIconLoginActive(data?.isIconLoginActive);
      console.log(`data?.applicativo =`, data?.applicativo);
      console.log(`isShopActive =`, data?.isShopActive);
      console.log(`isIconLoginActive =`, data?.isIconLoginActive);
    })
      .catch((er) => {
        console.log(er);
      });
  }, [setApplicativo, setIsShopActive, isIconLoginActive])


  return (

    <Box
      display={userInfo.isAdmin ? "block" : "none"}
      sx={{
        paddingTop: 0, paddingBottom: 0, paddingLeft: 0, paddingRight: 2,
      }}
    >

      <AppBar position="static" sx={{ bgcolor: "#e9e9e9" }} >

        <Container maxWidth="xl">

          <Toolbar disableGutters variant='dense' sx={{ minHeight: 40, height: 40 }}>

            <Box display={applicativo === 'mystudio' ? "block" : "none"} >

              <Box sx={{ flexGrow: 1, display: { xs: 'flex', md: 'none' } }}>

                <IconButton
                  size="large"
                  aria-label="account of current user"
                  aria-controls="menu-appbar"
                  aria-haspopup="true"
                  onClick={handleOpenNavMenu}
                  color="navy"
                >
                  <MenuIcon />
                </IconButton>

                <Menu
                  id="menu-appbarAdmin"
                  anchorEl={anchorElNavAdmin}
                  anchorOrigin={{
                    vertical: 'bottom',
                    horizontal: 'left',
                  }}
                  keepMounted
                  transformOrigin={{
                    vertical: 'top',
                    horizontal: 'left',
                  }}
                  open={Boolean(anchorElNavAdmin)}
                  onClose={handleCloseNavMenu}
                  sx={{ display: { xs: 'block', md: 'none' } }}
                >
                  {itemsMenuAdminStudio.map((page) => (
                    <MenuItem key={page}>
                      <Button
                        key={page.text}
                        href={page.href}
                      >
                        {page.text}
                      </Button>
                    </MenuItem>
                  ))}

                </Menu>
              </Box>

              <Box sx={{ flexGrow: 1, display: { xs: 'none', md: 'flex' } }}>

                {itemsMenuAdminStudio.map((page) => (
                  <Button
                    key={page.text}
                    onClick={handleCloseNavMenu}
                    sx={{ my: 2, color: 'navy', display: 'block' }}
                    href={page.href}
                  >
                    {page.text}
                  </Button>
                ))}

              </Box>

            </Box>

            <Box display={applicativo === 'myshop' ? "block" : "none"} >

              <Box sx={{ flexGrow: 1, display: { xs: 'flex', md: 'none' } }}>

                <IconButton
                  size="large"
                  aria-label="account of current user"
                  aria-controls="menu-appbar"
                  aria-haspopup="true"
                  onClick={handleOpenNavMenu}
                  color="navy"
                >
                  <MenuIcon />
                </IconButton>

                <Menu
                  id="menu-appbarAdmin"
                  anchorEl={anchorElNavAdmin}
                  anchorOrigin={{
                    vertical: 'bottom',
                    horizontal: 'left',
                  }}
                  keepMounted
                  transformOrigin={{
                    vertical: 'top',
                    horizontal: 'left',
                  }}
                  open={Boolean(anchorElNavAdmin)}
                  onClose={handleCloseNavMenu}
                  sx={{ display: { xs: 'block', md: 'none' } }}
                >
                  {itemsMenuAdminShop.map((page) => (
                    <MenuItem key={page}>
                      <Button
                        key={page.text}
                        href={page.href}
                      >
                        {page.text}
                      </Button>
                    </MenuItem>
                  ))}

                </Menu>
              </Box>

              <Box sx={{ flexGrow: 1, display: { xs: 'none', md: 'flex' } }}>

                {itemsMenuAdminShop.map((page) => (
                  <Button
                    key={page.text}
                    onClick={handleCloseNavMenu}
                    sx={{ my: 2, color: 'navy', display: 'block' }}
                    href={page.href}
                  >
                    {page.text}
                  </Button>
                ))}

              </Box>

            </Box>

          </Toolbar>

        </Container>

      </AppBar>

    </Box>

  );
};

export default AdminMenuComponent;
